import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from 'src/app/private/shared/component/sidebar/sidebar.component';
import { HeaderComponent } from "../../shared/component/header/header.component";
import { Toast } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { GlobalToastComponent } from "../../../../global-toast.component";
import { LayoutService } from 'src/app/layout/service/layout.service';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-main',
  imports: [RouterModule, SidebarComponent, HeaderComponent, GlobalToastComponent,CommonModule],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss'
})
export class MainComponent {
  sidebarWidth = 60
  isInitialized$: Observable<boolean>;

  constructor(private layoutService: LayoutService) {
    this.isInitialized$ = this.layoutService.initialized$
  }

  ngOnInit() {

  }

  onSidebarWidthChange(width: any) {
    this.sidebarWidth = width
  }
}
